import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Chatbot.css';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { text: "Hi! I'm Suraj Kumar Sah's AI assistant. How can I help you?", sender: 'bot' }
  ]);
  const [input, setInput] = useState('');

  const responses = {
    'hello': "Hello! Nice to meet you. I'm here to tell you more about Suraj Kumar Sah.",
    'skills': "Suraj Kumar Sah has expertise in JavaScript, React, Node.js, Python, Flutter, AWS, Docker, and more. Check out the Skills page for details!",
    'experience': "Suraj Kumar Sah has worked as a Flutter Intern at mbank Technology, Junior Software Engineer at Teclainfrastructure, and is the Founder of Solutionspath Tech.",
    'education': "Suraj Kumar Sah passout from Jain University with B.Tech in IT Engineering (2020-2024) with 100% SII Scholarship. Completed 12th at P.D.C.P. College (2017-2019) and 10th at Advance Learner Himalayan English Boarding School, Jaleswor, Mohottari, Nepal (2016). He has also published 2 research papers in international journals on blockchain technology!",
    'research': "Suraj Kumar Sah has published 2 research papers: (1) 'Online Voting System Using Blockchain Technology' in IJSERM Journal (Volume 8, Issue 04, April 2024) and (2) 'Blockchain Shipment Management Tracking System' in IRJMETS Journal (Volume 06, August 2024).",
    'scholarship': "Suraj Kumar Sah was awarded with 100% SII Scholarship Programs during his B.Tech degree at Jain University (2020-2024).",
    'blockchain': "Suraj Kumar Sah has expertise in Blockchain Technology and has published research papers on Online Voting System and Blockchain Shipment Management Tracking System.",
    'contact': "You can reach Suraj Kumar Sah at surajshah0915@gmail.com or chat on WhatsApp: +977 9844511713. Visit the Contact page for more options!",
    'github': "Check out Suraj Kumar Sah's GitHub: https://github.com/Suraj0915",
    'linkedin': "Connect with Suraj Kumar Sah on LinkedIn: https://www.linkedin.com/in/surajkumarsah0915/",
    'twitter': "Follow Suraj Kumar Sah on Twitter: @SurajShah47151",
    'youtube': "Subscribe to Suraj Kumar Sah's YouTube channel: https://www.youtube.com/@Mr.Shah0915",
    'whatsapp': "Chat with Suraj Kumar Sah on WhatsApp: +977 9844511713",
    'social': "Connect with Suraj Kumar Sah on GitHub, LinkedIn, Twitter, YouTube, or WhatsApp! Ask me for specific links.",
    'subscribe': "Subscribe to Suraj Kumar Sah's YouTube channel: https://www.youtube.com/@Mr.Shah0915",
    'company': "Suraj Kumar Sah founded Solutionspath Technology. Check out the Company page for more details!",
    'default': "I'm not sure about that. Feel free to ask about Suraj's skills, experience, education, projects, contact info, or social media! You can also chat with him directly on WhatsApp."
  };

  const handleSend = () => {
    if (input.trim()) {
      const userMessage = { text: input, sender: 'user' };
      setMessages([...messages, userMessage]);

      const response = getResponse(input.toLowerCase());
      setTimeout(() => {
        setMessages(prev => [...prev, { text: response, sender: 'bot' }]);
      }, 1000);

      setInput('');
    }
  };

  const getResponse = (query) => {
    for (let key in responses) {
      if (query.includes(key)) {
        return responses[key];
      }
    }
    return responses['default'];
  };

  return (
    <>
      <motion.div
        className="chatbot-toggle"
        onClick={() => setIsOpen(!isOpen)}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        💬
      </motion.div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="chatbot"
            initial={{ opacity: 0, scale: 0.8, y: 50 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 50 }}
            transition={{ duration: 0.3 }}
          >
            <div className="chatbot-header">
              <h4>AI Assistant</h4>
              <button onClick={() => setIsOpen(false)}>×</button>
            </div>
            <div className="chatbot-messages">
              {messages.map((msg, index) => (
                <div key={index} className={`message ${msg.sender}`}>
                  {msg.text}
                </div>
              ))}
            </div>
            <div className="chatbot-input">
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSend()}
                placeholder="Ask me something..."
              />
              <button onClick={handleSend}>Send</button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Chatbot;